var _excluded = ["color", "size", "name", "nameForId", "nameForClasses", "className"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
var brandClasses = {
  base: 'Union__brands-v1__base',
  'theknot-primary-color': 'Union__brands-v1__theknot Union__brands-v1--color-primary',
  'theknot-secondary-color': 'Union__brands-v1__theknot Union__brands-v1--color-secondary'
};
var BrandLogo = function BrandLogo(_ref) {
  var color = _ref.color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg' : _ref$size,
    name = _ref.name,
    _ref$nameForId = _ref.nameForId,
    nameForId = _ref$nameForId === void 0 ? name : _ref$nameForId,
    _ref$nameForClasses = _ref.nameForClasses,
    nameForClasses = _ref$nameForClasses === void 0 ? name : _ref$nameForClasses,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutProperties(_ref, _excluded);
  var colorClass = brandClasses["".concat(nameForClasses, "-").concat(color, "-color")] || '';
  var ownClassName = "Union__brands-v1__icon-".concat(nameForClasses, "_").concat(size);
  var id = "Union__brands-v1__icon-".concat(nameForId, "_").concat(size);
  var classes = [brandClasses.base, className, colorClass, ownClassName].join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: classes,
    "aria-labelledby": "".concat(id, "_title"),
    role: "img"
  }, props), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#".concat(id)
  }));
};
export default BrandLogo;